<template>
  <div id="avantage">
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div
                class="col-lg-4"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-notification-70"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">
                    <!-- Communication créative -->
                    Créativité
                  </h6>
                  <p class="description mt-3">
                    Avec Panneau mobile, chaque campagne est une histoire en
                    soi. Nous faisons de votre vision une réalité.
                    <!-- Plongez dans l'univers créatif de panneau mobile, ou chaque
                    campagne est une histoire en soi, nous transformons votre
                    vision en réalité.laissez nous vous guider vers de nouveaux
                    sommets dans le monde de la publicité -->
                    <!-- Nous proposons des formats de publicité extérieure originale
                    qui se remarquent, attirent l’attention, on s’en souvient,
                    on en parle. -->
                  </p>
                  <!-- <br /> -->

                  <!--                                    <div>-->
                  <!--                                        <badge type="primary" rounded>design</badge>-->
                  <!--                                        <badge type="primary" rounded>system</badge>-->
                  <!--                                        <badge type="primary" rounded>creative</badge>-->
                  <!--                                    </div>-->
                  <!--                                    <base-button tag="a" href="#" type="primary" class="mt-4">-->
                  <!--                                        Learn more-->
                  <!--                                    </base-button>-->
                </card>
              </div>

              <div class="col-lg-4" data-aos="fade-up" data-aos-duration="1300">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-square-pin"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">
                    <!-- Communication de proximité -->
                    Proximité
                  </h6>
                  <p class="description mt-3">
                    <!-- Chaque marque est unique, tout comme ses besoins en
                    communication. Notre approche est une analyse approfondie de
                    vos objectifs et de votre votre cible -->
                    Panneau Mobile est au plus près de la cible pour s'insérer
                    dans son quotidien et au coeur des zones de charlandise.
                  </p>
                  <!--                                    <div>-->
                  <!--                                        <badge type="success" rounded>business</badge>-->
                  <!--                                        <badge type="success" rounded>vision</badge>-->
                  <!--                                        <badge type="success" rounded>success</badge>-->
                  <!--                                    </div>-->
                  <!--                                    <base-button tag="a" href="#" type="success" class="mt-4">-->
                  <!--                                        Learn more-->
                  <!--                                    </base-button>-->
                </card>
              </div>

              <div
                class="col-lg-4"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-settings"
                    type="warning"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-warning text-uppercase">
                    <!-- Communication sur mesure -->
                    Personnalisation
                  </h6>
                  <p class="description mt-3">
                    Chez Panneau Mobile, nous vehiculons le message adapté à
                    votre produit et à la cible.
                  </p>
                  <br />
                  <!--                                    <div>-->
                  <!--                                        <badge type="warning" rounded>marketing</badge>-->
                  <!--                                        <badge type="warning" rounded>product</badge>-->
                  <!--                                        <badge type="warning" rounded>launch</badge>-->
                  <!--                                    </div>-->
                  <!--                                    <base-button tag="a" href="#" type="warning" class="mt-4">-->
                  <!--                                        Learn more-->
                  <!--                                    </base-button>-->
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style></style>
